// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__qjZo7","blockMsg":"Message_blockMsg__Dtt61","avatar":"Message_avatar__I4U7B","avatarBg":"Message_avatarBg__O2nYs","nameAuthor":"Message_nameAuthor__3JvIT"};